import store from '@/store';
import router from '..';
import {
  LOGIN_ROUTE,
  SIGNUP_ORGANIZATION_ROUTE,
  EMAIL_VERIFICATION_WALL_ROUTE,
  // SUBSCRIPTION_WALL_ROUTE,
  // DASHBOARD_ROUTE,
  // ERROR_ROUTE,
} from '@/router/routes';
import {
  CLEAR_ERRORMSG,
  UPDATE_ROUTER_LOADER,
} from '@/store/action_types';
import { resetLoaders } from '@/utils/loaders';
import { RouteLocationNormalized } from 'vue-router';

export const ifNotAuthDeny = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: Function
) => {
  store.dispatch(UPDATE_ROUTER_LOADER, true);

  console.log('fromm', from);

  try {
    // clear error messages
    store.dispatch(CLEAR_ERRORMSG);

    // clear isLoading states
    resetLoaders();

    if (
      store.getters.sessionToken == null ||
      store.getters.account.data == null
    ) {
      router.push({ name: LOGIN_ROUTE });
      return;
    }

    // if (
    //   store.getters.account.data &&
    //   !store.getters.account.data.isEmailVerified
    // ) {
    //   if (to.name !== EMAIL_VERIFICATION_WALL_ROUTE) {
    //     return router.replace({ name: EMAIL_VERIFICATION_WALL_ROUTE });
    //   }
    // }

    // if (!store.getters.account.data.organizationId) {
    //   if (to.name === SIGNUP_ORGANIZATION_ROUTE) {
    //     next();
    //   }

    //   return router.replace({ name: SIGNUP_ORGANIZATION_ROUTE });
    // }

    // try {
    //   await store.dispatch(GET_ORGANIZATION_ACTIVE_SUBSCRIPTION, {
    //     organizationId: store.getters.account.data.organizationId,
    //   });
    // } catch (error) {
    //   console.error('Failed to fetch subscription:', error);

    //   return next({ name: ERROR_ROUTE, query: { from: from.fullPath } });
    // }

    // if (!store.getters.organizationActiveSubscription.data) {
    //   // If organizationActiveSubscription data is null, allow access to SUBSCRIPTION_WALL_ROUTE
    //   if (to.name !== SUBSCRIPTION_WALL_ROUTE) {
    //     console.log('Redirecting to SUBSCRIPTION_WALL_ROUTE');
    //     return next({ name: SUBSCRIPTION_WALL_ROUTE });
    //   }
    // } else {
    //   // If organizationActiveSubscription data is not null, prevent access to SUBSCRIPTION_WALL_ROUTE
    //   if (to.name === SUBSCRIPTION_WALL_ROUTE) {
    //     console.log('Redirecting to DASHBOARD_ROUTE');
    //     return next({ name: DASHBOARD_ROUTE });
    //   } else {
    //     return next();
    //   }
    // }

    // Allow navigation if none of the above conditions are met
    next();
  } finally {
    // Ensure the loader is turned off on function exit
    // store.dispatch(UPDATE_ROUTER_LOADER, false);
  }
};
